import React from "react";
import "../../style.scss";
import Window from "../../../../elements/window";
import Slide1 from "./views/slide1";
import Slide2 from "./views/slide2";
import { useAppContext } from "../../../../../../AppContext";

function User() {
  const { user, chimeraserv } = useAppContext();
  const props = { user, chimeraserv };
  return (
    <section className="admin">
      <div className="viewTitle">Admin Dashboard</div>
      <div className="viewBody">
        <Window
          user={props.user}
          chimeraserv={props.chimeraserv}
          title={"List of Accounts"}
        >
          <Slide1 />
        </Window>

        <Window
          user={props.user}
          chimeraserv={props.chimeraserv}
          title={"All Outlets"}
        >
          <Slide2 />
        </Window>
      </div>
    </section>
  );
}

export default User;
